// @ts-nocheck
import _ from 'lodash';
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../../configs';
import { toastTypes } from '../../enums';
import getRoot from '../root';
import useFormsStore from '../forms';

const useTypeformStore = create((set, get) => ({
  configs: { enabled: false },
  loading: { configs: false, getTokens: false, forms: false, updateConfigs: false, retrieveForms: false },
  formsLoading: new Set(),
  formData: {},
  activePage: 1,
  search: '',

  updateActivePage: (activePage) => {
    set({ activePage });
    get().retrieveForms({ page: activePage, search: get().search });
  },
  updateSearch: (searchQuery) => set({ search: searchQuery }),
  handleSearch: () => get().retrieveForms({ search: get().search }),

  updateFormContainerId: (_e, { name, value }) => {
    const formData = _.cloneDeep(get().formData);
    const targetForm = (formData.forms || []).find((form) => form.id === name);
    if (targetForm) _.set(targetForm, 'settings.google_tag_manager', value);
    set({ formData });
  },

  reset: () => set({
    configs: {},
    loading: _.mapValues(get().loading, () => false),
  }),

  setConfigField: (name, value) => set((s) => ({ configs: { ...s.configs, [name]: value } })),

  getAuthUrl: async () => {
    try {
      const res = await axios.get(`${API_URL}/api/integrations/Typeform/auth-url`);
      if (res.data.success) {
        window.open(res.data.authUrl, '_blank');
        return res.data.authUrl;
      }
      throw new Error('Failed to get auth url...');
    } catch (e) {
      return null;
    }
  },

  getConfigs: async () => {
    try {
      set((s) => ({ loading: { ...s.loading, configs: true } }));
      const { data } = await axios.get(`${API_URL}/api/integrations/Typeform/config`);
      if (data.success) set((s) => ({ configs: { ...s.configs, ...data.config } }));
      const { configs, loading } = get();
      if (configs.enabled && !loading.retrieveForms) {
        get().retrieveForms({ search: get().search, page: get().activePage });
      }
    } catch (e) { /* ignore */ }
    set((s) => ({ loading: { ...s.loading, configs: false } }));
  },

  updateConfigs: async () => {
    const root = getRoot();
    try {
      set((s) => ({ loading: { ...s.loading, configs: true } }));
      const { data } = await axios.post(`${API_URL}/api/integrations/Typeform/config`, { ...get().configs });
      if (data.success) {
        root.success('Successfully updated the configurations.', toastTypes.typeFormUpdateConfigs);
        root.clearToast(toastTypes.typeFormUpdateConfigs);
      } else throw new Error();
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.typeFormUpdateConfigs);
    } finally {
      get().getConfigs();
      set((s) => ({ loading: { ...s.loading, configs: false } }));
    }
  },

  getTokens: async (code) => {
    const root = getRoot();
    try {
      set((s) => ({ loading: { ...s.loading, getTokens: true } }));
      const { data } = await axios.get(`${API_URL}/api/integrations/Typeform/get-tokens?code=${code}`);
      if (data.success) {
        root.success('Typeform integration successful.', toastTypes.typeFormGetTokens);
        root.clearToast(toastTypes.typeFormGetTokens);
      } else throw new Error();
    } catch (e) {
      root.failure('Typeform integration unsuccessful.', toastTypes.typeFormGetTokens);
    } finally {
      set((s) => ({ loading: { ...s.loading, getTokens: false } }));
    }
  },

  retrieveForms: async (queryParams) => {
    const root = getRoot();
    try {
      set((s) => ({ loading: { ...s.loading, retrieveForms: true } }));
      const { data } = await axios.get(`${API_URL}/api/integrations/Typeform/retrieve-forms`, { params: queryParams });
      if (data.success) set({ formData: data.forms });
    } catch (e) {
      root.failure('Failed to retrieve forms...');
    } finally {
      set((s) => ({ loading: { ...s.loading, retrieveForms: false } }));
    }
  },

  approveForm: async (formId, gtmId, typeformUrl) => {
    const root = getRoot();
    try {
      set((s) => {
        const next = new Set(s.formsLoading);
        next.add(formId);
        return { formsLoading: next };
      });
      if (!gtmId) throw new Error();

      const { data: connectRes } = await axios.post(`${API_URL}/api/integrations/Typeform/forms/${formId}/gtm-container/${gtmId}`);
      const { data: approveRes } = await axios.post(`${API_URL}/api/integrations/Typeform/approve-form?formId=${formId}`);

      if (connectRes.success && approveRes.success) {
        axios.post(`${API_URL}/api/analytics/create`, { urls: [typeformUrl] });
        root.success('Form approved!', toastTypes.approveForm);
        root.clearToast(toastTypes.approveForm);
        get().retrieveForms({ search: get().search, page: get().activePage });
        useFormsStore.getState().getFormLinks();
      }
    } catch (e) {
      root.failure('Form approval unsuccessful.', toastTypes.approveForm);
    } finally {
      set((s) => {
        const next = new Set(s.formsLoading);
        next.delete(formId);
        return { formsLoading: next };
      });
    }
  },
}));

export default useTypeformStore;
